import { render, staticRenderFns } from "./RemoveIcon.vue?vue&type=template&id=9c5312a4&"
import script from "./RemoveIcon.vue?vue&type=script&lang=js&"
export * from "./RemoveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports